import axios from 'axios'
import { createPrefix } from 'utils/create-prefix'

export class PreRegistrationService {
  constructor() {
    this.endpoints = {
      ...createPrefix('/admin/pre-registrations', {
        beneficiary: '',
      }),
      ...createPrefix('/self-register', {
        createBeneSelfReg: '/',
      }),
    }
  }

  static create() {
    return new PreRegistrationService()
  }

  async createPreRegBene(form, token) {
    const servicePath = this.endpoints.createBeneSelfReg() + token
    const { data } = await axios.post(servicePath, form)
    return data
  }

  async getLinkForBeneConfirmSignUp(id) {
    const servicePath = this.endpoints.beneficiary()
    const { data } = await axios.get(`${servicePath}/${id}/link`)
    return data
  }
}
